import {
    updateOnImport,
    update,
    find,
    paralizeCompanyDebts,
    startCompanyDebts,
    loadBusinessAreasRequest,
    bankStatement,
} from 'src/repositories/company.repository';

/**
 * Action Types
 */
export const COMPANY_UPDATING = 'COMPANY_UPDATING';
export const COMPANY_UPDATED = 'COMPANY_UPDATE';

export const COMPANY_LOADING = 'COMPANY_LOADING';
export const COMPANY_LOADED = 'COMPANY_LOADED';

export const DEBTS_PARALIZE_LOADING = 'DEBTS_PARALIZE_LOADING';
export const DEBTS_PARALIZED = 'DEBTS_PARALIZED';

export const DEBTS_START_LOADING = 'DEBTS_PARALIZE_LOADING';
export const DEBTS_STARTED_CHARGES = 'DEBTS_STARTED_CHARGES';

export const BUSINESS_AREAS_LOADING = 'BUSINESS_AREAS_LOADING';
export const BUSINESS_AREAS_LOADED = 'BUSINESS_AREAS_LOADED';

export const ASSOCIATED_PAYMENT_GATEWAY = 'ASSOCIATED_PAYMENT_GATEWAY';


/**
 * Action Creators
 */

export const updatingCompany = isUpdating => ({
    type: COMPANY_UPDATING,
    payload: isUpdating,
});

export const updatedCompany = company => ({
    type: COMPANY_UPDATED,
    payload: company,
});

export const loadingCompany = isLoading => ({
    type: COMPANY_LOADING,
    payload: isLoading,
});

export const loadedCompany = company => ({
    type: COMPANY_LOADED,
    payload: company,
});

export const loadingParalizeDebts = isLoading => ({
    type: DEBTS_PARALIZE_LOADING,
    payload: isLoading,
});

export const paralizedDebts = response => ({
    type: DEBTS_PARALIZED,
    payload: response,
});

export const loadingStartDebts = isLoading => ({
    type: DEBTS_START_LOADING,
    payload: isLoading,
});

export const startedDebtsCharges = response => ({
    type: DEBTS_STARTED_CHARGES,
    payload: response,
});

export const loadingBusinessAreas = isLoading => ({
    type: BUSINESS_AREAS_LOADING,
    payload: isLoading,
});

export const loadedBusinessAreas = response => ({
    type: BUSINESS_AREAS_LOADED,
    payload: response,
});

/**
 * Actions
 */

/**
 * Update company data
 * @param {integer} id
 * @param {object} company
 * @param {boolean} isImport
 */
export const updateCompany = (id, company, isImport = false) => (dispatch) => {
    dispatch(updatingCompany(true));
    const promise = isImport ? updateOnImport(id, company) : update(id, company);
    return promise
        .then(({ data }) => {
            dispatch(updatedCompany(data));
        })
        .finally(() => {
            dispatch(updatingCompany(false));
        });
};

export const loadCompany = id => (dispatch) => {
    dispatch(loadingCompany(true));
    return find(id)
        .then(({ data }) => {
            dispatch(loadedCompany(data));
        })
        .finally(() => {
            dispatch(loadingCompany(false));
        });
};

export const paralizeDebts = () => (dispatch) => {
    dispatch(loadingParalizeDebts(true));
    return paralizeCompanyDebts()
        .then(({ data }) => {
            dispatch(paralizedDebts(data));
        })
        .finally(() => {
            dispatch(loadingParalizeDebts(false));
        });
};

export const startDebts = () => (dispatch) => {
    dispatch(loadingStartDebts(true));
    return startCompanyDebts()
        .then(({ data }) => {
            dispatch(startedDebtsCharges(data));
        })
        .finally(() => {
            dispatch(loadingStartDebts(false));
        });
};

export const loadBusinessAreas = () => (dispatch) => {
    dispatch(loadingBusinessAreas(true));
    return loadBusinessAreasRequest()
        .then(({ data }) => {
            dispatch(loadedBusinessAreas(data));
        })
        .finally(() => {
            dispatch(loadingBusinessAreas(false));
        });
};


export const LOAD_BANK_STATEMENT_REQUEST = 'LOAD_BANK_STATEMENT_REQUEST';
export const LOAD_BANK_STATEMENT_SUCCESS = 'LOAD_BANK_STATEMENT_SUCCESS';
export const LOAD_BANK_STATEMENT_ERROR = 'LOAD_BANK_STATEMENT_ERROR';

export const loadBankStatement = params => (dispatch) => {
    dispatch({ type: LOAD_BANK_STATEMENT_REQUEST, payload: null });

    return bankStatement(params)
        .then(res => dispatch({ type: LOAD_BANK_STATEMENT_SUCCESS, payload: res.data }))
        .catch((e) => {
            dispatch({ type: LOAD_BANK_STATEMENT_ERROR, payload: e });
            throw e;
        });
};
